/**
 * Traffic link dialog tiles — one per enabled tracker. With Voluum and Binom only
 * this renders exactly the two tiles (and grid) the dialog always had.
 * For Media Devoted | Created By Ciro Autiero
 */

import type { FC, ReactNode } from 'react';
import { assertNever, trackerFromEnum, trackerLabel } from '@trafficpulse/shared';

import binomLogo from '@/assets/traffic/binom.png';
import voluumLogo from '@/assets/traffic/voluum.png';
import { ProviderBadge } from '@/components/ui';
import type { PatchTrafficProvider } from '@/hooks';

import { ProviderPickCard } from '@/pages/admin/SmswiserCampaignDetailPage/sections/stats-traffic/ProviderPickCard';

interface TrafficProviderTilesProps {
  choices: readonly PatchTrafficProvider[];
  value: PatchTrafficProvider;
  onChange: (provider: PatchTrafficProvider) => void;
  disabled: boolean;
}

function tileArt(provider: PatchTrafficProvider): { image?: string; mark?: ReactNode } {
  switch (provider) {
    case 'VOLUUM':
      return { image: voluumLogo };
    case 'BINOM':
      return { image: binomLogo };
    case 'TRES_COMMAS':
      return { mark: <ProviderBadge provider="tres-commas" noun="tracker" /> };
    default:
      return assertNever(provider, 'traffic provider');
  }
}

export const TrafficProviderTiles: FC<TrafficProviderTilesProps> = ({ choices, value, onChange, disabled }) => (
  <div className={choices.length > 2 ? 'grid grid-cols-3 gap-2' : 'grid grid-cols-2 gap-2'}>
    {choices.map((provider) => (
      <ProviderPickCard
        key={provider}
        label={trackerLabel(trackerFromEnum(provider))}
        {...tileArt(provider)}
        selected={value === provider}
        onSelect={() => onChange(provider)}
        disabled={disabled}
      />
    ))}
  </div>
);
